import { findLast } from 'lodash';

// ***************************************************************************************
// calculateTime est une fonction permet de calculer la durée d'un nouveau mot
// ***************************************************************************************
export function calculateTime(startTime, endTime, oldText, newText) {
  const duration = endTime - startTime;
  const time = (duration / oldText.length) * newText.length;
  const inOutTime = parseFloat((startTime + time).toFixed(2));

  if (isNaN(inOutTime)) {
    return endTime;
  }

  return inOutTime;
}

const markWordKeys = [
  {
    key: 'CHECKWORD',
    value: 1,
  },
  {
    key: 'NEWST',
    value: 2,
  },
  {
    key: 'TCIN',
    value: 4,
  },
  {
    key: 'TCOUT',
    value: 8,
  },
];

// ***************************************************************************************
// getMarkWord
// Récupérer le markword en fonction de la clé
// ***************************************************************************************
export function getMarkWord(key) {
  return markWordKeys.find((x) => x.key === key);
}

// ***************************************************************************************
// findMarkWords
// Trouver les bonnes clés avec la suite géométrique
// ***************************************************************************************
export function findMarkWords(target) {
  return markWordKeys.filter((item) => (target & item.value) !== 0);
}

// ***************************************************************************************
// copyToClipboard
// Copier dans le presse-papiers
// ***************************************************************************************
export function copyToClipboard(words) {
  let stringToCopy = '';

  for (let i = 0; i < words.length; i++) {
    const word = words[i];

    if (i !== 0 && !word.newline) {
      stringToCopy += ' ';
    }

    if (word.newline) {
      stringToCopy += '\n';
    }

    stringToCopy += word.text;
  }

  navigator.clipboard.writeText(stringToCopy).then(
    () => {
      console.log('presse-papiers modifié avec succès');
    },
    () => console.log("échec de l'écriture dans le presse-papiers")
  );
}

// ***************************************************************************************
// getWordByCoordinates()
// Permet de trouver le mot le plus proche des coordonnées X et Y
// ***************************************************************************************
export function getWordByCoordinates(
  words,
  offsetX,
  offsetY,
  findLastWord = true
) {
  let word = words.find(
    (word) =>
      word.x !== 0 &&
      word.y !== 0 &&
      word.startX <= offsetX &&
      offsetX <= word.endX &&
      word.startY <= offsetY &&
      offsetY <= word.endY
  );

  if (!word && findLastWord) {
    // si le mot n'existe pas, on va prendre le dernier mot de la ligne
    word = findLast(
      words,
      (word) =>
        word.x !== 0 &&
        word.y !== 0 &&
        word.startY <= offsetY &&
        offsetY <= word.endY
    );
  }

  return word;
}

// ***************************************************************************************
// getWordIndexByCoordinates()
// Permet de trouver l'index le plus proche des coordonnées X et Y
// ***************************************************************************************
export function getWordIndexByCoordinates(words, offsetX, offsetY) {
  return words.findIndex(
    (word) =>
      word.x !== 0 &&
      word.y !== 0 &&
      word.startX <= offsetX &&
      offsetX <= word.endX &&
      word.startY <= offsetY &&
      offsetY <= word.endY
  );
}

export function isLetterUpperCase(letter) {
  return letter === letter.toUpperCase();
}

export function isWordUpperCase(word) {
  return word === word.toUpperCase();
}

export function removePunctuation(text) {
  return text.replace(/[.,?!]+$/, '');
}

export function hasPunctuation(text) {
  const regex = /[.,?!]+$/;
  return regex.test(text);
}

export function hasDot(text) {
  const regex = /[.]+$/;
  return regex.test(text);
}

// ***************************************************************************************
// trapFocusElements permet de tabuler sur les éléments qu'on veut focused
// ***************************************************************************************
export function trapFocusElements(focusedElement, selector, shiftKey) {
  // Obtenir tous les éléments focusables dans le component
  const elements = document.querySelectorAll(selector);

  if (!elements.length) {
    return;
  }

  // Trouver l'index de l'élément focusé dans la liste des boutons
  const currentIndex = Array.prototype.indexOf.call(elements, focusedElement);

  let nextIndex;

  if (shiftKey) {
    nextIndex = (currentIndex - 1) % elements.length;

    if (nextIndex === -1) {
      nextIndex = elements.length - 1;
    }
  } else {
    nextIndex = (currentIndex + 1) % elements.length;
  }

  var nextButton = elements[nextIndex];
  if (nextButton) {
    nextButton.focus();
  }
}

// ***************************************************************************************
// wait permet d'attendre un certain temps avant de continuer
// ***************************************************************************************
export function wait(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

// ***************************************************************************************
// cloneTranscription permet de cloner l'objet avec certaines valeurs
// ***************************************************************************************
export function cloneTranscription(transcription) {
  return transcription.map((word) => ({
    text: word.text,
    startTime: word.startTime,
    endTime: word.endTime,
    newline: word.newline,
    color: word.color,
    italic: word.italic,
    markWord: word.markWord,
    speakerId: word.speakerId,
    submitted: word.submitted,
    stabilo: word.stabilo,
    rtl: word.rtl
  }));
}